package com.kinoshazam.screens.main

import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.dp
import com.kinoshazam.screens.main.medium.LeftAlignedCarouselRowV3
import com.kinoshazam.uiKit.components.carousel.CarouselNavButton
import com.kinoshazam.uiKit.components.videoItem.MediumBannerSkeleton
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.left
import kinoshazam.resources.generated.resources.right
import org.jetbrains.compose.resources.painterResource

@OptIn(ExperimentalFoundationApi::class)
@Composable
fun MediumBannerSkeletonCarousel() {
    LeftAlignedCarouselRowV3(
        items = List(6) { it },
        itemWidth = 164.dp,
        itemHeight = 280.dp,
        leftContent = { enabled, onClick ->
            CarouselNavButton(
                painter = painterResource(Res.drawable.left),
                enabled = enabled,
                contentDescription = "Prev",
                onClick = onClick,
            )
        },
        rightContent = { enabled, onClick ->
            CarouselNavButton(
                painter = painterResource(Res.drawable.right),
                enabled = enabled,
                contentDescription = "Next",
                onClick = onClick,
            )
        },
    ) { _, _, _ ->
        MediumBannerSkeleton(width = 164.dp)
    }
}
